import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import AddButton from "../../buttons/button";
import CloseIcon from "../../../assets/icons/close-icon";
import LoadingOverlay from "../../helper-components/overlay-loading";
import { useFormikContext } from "formik";
import ItemsSearchAddFeild from "../../forms/items-search-add-field";
import {
  binLocationListAction,
  catListAction,
  itemGroupListAction,
  itemTypeListAction,
  manufacturesListAction,
  productListAction,
  storeCityListAction,
  storeDistrictListAction,
  storeStateListAction,
  storesItemAction,
} from "../../../redux/actions/general-action";
import { useDispatch } from "react-redux";
import ItemsSelectField from "../../forms/items-select-field";
import ItemsInputField from "../../forms/items-input-field";
import { useNavigate } from "react-router-dom";
import { truncateString } from "../../helper-components/helper-function";
import { stockAuditLoadFiltersAction } from "../../../redux/actions/stock-details-audit-action";
import LoadingSpinner from "../../helper-components/loading-spinner";
import moment from "moment";

export default function AuditLoadFilters({
  open,
  setOpen,
  initialValues = {},
}) {
  const [formKey, setFormKey] = useState(0);
  const [corrDisplays, setCorrDisplays] = useState({});

  const [binLocationList, setBinLocationList] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [catList, setCatList] = useState([]);
  const [manufacturesList, setManufacturesList] = useState([]);
  const [itemGroup, setItemGroup] = useState([]);
  const [itemType, setItemType] = useState([]);

  const { values, setFieldValue, resetForm } = useFormikContext();

  useEffect(() => {
    if (open) {
      dispatch(itemGroupListAction(onitemGroupSuccess, onitemGroupError));
      dispatch(itemTypeListAction(onitemTypeSuccess, onitemTypeError));
      dispatch(
        manufacturesListAction(onmanufacturesSuccess, onmanufacturesError)
      );
      dispatch(catListAction(onCatSuccess, onCatError));
      dispatch(binLocationListAction(onSuccessBin, onerrorBin));
    }
  }, [open]);
  const onCatSuccess = (data) => {
    setCatList(
      data?.data?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };
  const onCatError = (data) => {
    // errorToast(data?.message);
  };
  const onmanufacturesSuccess = (data) => {
    setManufacturesList(
      data?.data?.map((item) => {
        return {
          label: item?.name,
          value: item?.id,
        };
      })
    );
  };
  const onmanufacturesError = (data) => {
    setManufacturesList([]);
  };
  const onitemGroupSuccess = (data) => {
    setItemGroup(
      data?.data?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };
  const onitemGroupError = (data) => {};
  const onitemTypeSuccess = (data) => {
    setItemType(
      data?.data?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };
  const onitemTypeError = (data) => {};
  const onSuccessBin = (data) => {
    setBinLocationList(
      data?.data?.map((item) => ({
        value: item?.bin_no_id,
        label: item?.bin_location_no,
      }))
    );
  };
  const onerrorBin = () => {};

  useEffect(() => {
    if (open) {
      const {
        initials,
        item_category,
        item_group,
        bin_location,
        item_type,
        manufacturer,
      } = values?.filters || {};

      // Check if at least one field has a value
      const hasAnyFilter =
        initials?.trim() ||
        item_category ||
        item_group ||
        bin_location ||
        item_type ||
        manufacturer;

      if (hasAnyFilter) {
        setLoading(true);
        dispatch(
          stockAuditLoadFiltersAction(
            {
              initials: initials || "",
              item_category: item_category || "",
              item_group: item_group || "",
              bin_location: bin_location || "",
              item_type: item_type || "",
              manufacturer: manufacturer || "",
            },
            onSuccess,
            onError
          )
        );
      } else {
        // Optional: clear the items list if no filters are selected
        setFieldValue(`filters.items`, []);
      }
    }
  }, [
    open,
    values?.filters?.initials,
    values?.filters?.item_category,
    values?.filters?.item_group,
    values?.filters?.bin_location,
    values?.filters?.item_type,
    values?.filters?.manufacturer,
  ]);
  const onSuccess = (data) => {
    const enrichedItems = data?.data?.map((item) => ({
      ...item,
      item_batch_purchase_rate:
        (
          parseFloat(item?.item_batch_final_purchase_rate || 0) /
          parseFloat(item?.item_pack_size || 0)
        ).toFixed(2) || 0,
      item_exp_date: moment(item?.item_exp_date).format("YYYY-MM-DD") ?? null,
      item_correction_quantity: 0,
      updated_quantity: item?.item_quantity || 0,
      item_current_amount: "0.00",
      item_total_amount: "0.00",
      item_adjusted_amount: "0.00",
      item_current_adjusted_diff: "0.00",
      correction: "+",
    }));

    setFieldValue(`filters.items`, enrichedItems);
    setLoading(false);
  };
  const onError = (data) => {
    setLoading(false);

    setFieldValue(`filters.items`, []);
  };

  const handleCorrectionQtyChange = (index, correctionQty) => {
    const updatedItems = [...values?.filters?.items];
    const item = updatedItems[index];

    const item_quantity = parseFloat(item?.item_quantity || 0);
    const item_batch_purchase_rate = parseFloat(
      item?.item_batch_purchase_rate || 0
    );
    const correctionQtyParsed = parseFloat(correctionQty || 0);

    const updated_quantity = item_quantity + correctionQtyParsed;

    const item_current_amount = (
      item_quantity * item_batch_purchase_rate
    ).toFixed(2);
    const item_total_amount = (
      updated_quantity * item_batch_purchase_rate
    ).toFixed(2);
    const item_adjusted_amount =
      updated_quantity * item_batch_purchase_rate -
      item_quantity * item_batch_purchase_rate;
    const item_current_adjusted_diff = item_adjusted_amount.toFixed(2);
    const correction = item_adjusted_amount === 0 ? "+" : "-";

    updatedItems[index] = {
      ...item,
      item_correction_quantity: correctionQtyParsed,
      updated_quantity,
      item_current_amount,
      item_total_amount,
      item_adjusted_amount: item_adjusted_amount.toFixed(2),
      item_current_adjusted_diff,
      correction,
    };

    setFieldValue(`filters.items`, updatedItems);
  };


  console.log(values, "fgdgdfgdfgfdgdfgdfgdfg");
  

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          setOpen(false);
          setFieldValue("filters", {
            initials: "",
            item_category: "",
            item_group: "",
            bin_location: "",
            item_type: "",
            manufacturer: "",
            items: [],
          });
          //   setFieldValue(`otherStores`, {});
        }}
      >
        <div className="fixed inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-[#0000004D]" />
          </Transition.Child>

          <div className="fixed inset-0 flex justify-end">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-300"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-300"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className="h-full w-[80%] md:w-[70%] bg-white overflow-y-auto rounded-tl-lg rounded-bl-lg shadow-xl">
                {/* Header */}
                <div
                  className="h-[61px] bg-[var(--slide-panel-head-bg)] px-3 flex items-center justify-between border-b"
                  style={{ borderColor: "var(--slide-panel-border)" }}
                >
                  <div
                    style={{
                      maxHeight: "32px",
                      color: "var(--slide-panel-h-fg)",
                      fontSize: "var(--slide-panel-h-fs)",
                      fontWeight: "var(--slide-panel-h-fw)",
                    }}
                    className="min-w-[75%] "
                  >
                    Load With Filters
                  </div>
                  <AddButton
                    onclkFn={() => {
                      setOpen(false);
                      // setProductDetails({ item_id: "" });
                    }}
                    icon={
                      <CloseIcon
                        width="12px"
                        height="12px"
                        fill="var(--close-button-fg)"
                      />
                    }
                    text={
                      <span>
                        Close <span className="opacity-50">(X)</span>{" "}
                      </span>
                    }
                    className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                  />
                </div>

                {/* Product Detail Panel */}
                <div
                  className="px-3 "
                  style={{
                    maxHeight: `calc(100% - 120px)`,
                    minHeight: `calc(100% - 120px)`,
                    height: `calc(100% - 120px)`,
                  }}
                >
                  <div
                    key={formKey}
                    className="flex justify-between pt-3 h-[15rem]"
                  >
                    <div className="w-[48%] flex flex-col gap-[1rem]">
                      <ItemsInputField
                        name={`filters.initials`}
                        label="Initials "
                        isLabelReq={true}
                        placeholder="Search Initials"
                      />
                      <ItemsSelectField
                        // key={values.filters.item_type}
                        //   disabled={disabled}
                        options={itemType}
                        name={`filters.item_type`}
                        label="Item Type"
                        isLabelReq={true}
                        placeholder="Select Item Type"
                      />
                      <ItemsSelectField
                        // key={values.filters.item_category}
                        //   disabled={disabled}
                        options={catList}
                        name={`filters.item_category`}
                        label="Category"
                        isLabelReq={true}
                        placeholder="Select Category"
                      />
                    </div>
                    <div className="w-[48%] flex flex-col gap-[1rem]">
                      <ItemsSelectField
                        // key={values.filters.manufacturer}
                        //   disabled={disabled}
                        options={manufacturesList}
                        name={`filters.manufacturer`}
                        label="Company "
                        isLabelReq={true}
                        placeholder="Select Company"
                      />
                      <ItemsSelectField
                        // key={values.filters.bin_location}
                        //   disabled={disabled}
                        options={binLocationList}
                        name={`filters.bin_location`}
                        label="Bin Location"
                        isLabelReq={true}
                        placeholder="Select Location"
                      />
                      <ItemsSelectField
                        // key={values.filters.item_group}
                        //   disabled={disabled}
                        options={itemGroup}
                        name={`filters.item_group`}
                        label="Item Group"
                        isLabelReq={true}
                        placeholder="Select Item Group"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      maxHeight: `calc(100% - 15rem)`,
                      height: `calc(100% - 15rem)`,
                      minHeight: `5rem`,
                    }}
                    className="tab-container rounded-[8px] "
                  >
                    {loading ? (
                      <LoadingSpinner />
                    ) : (
                      <table className="w-full border-collapse mt-0">
                        <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                          <tr className="relative h-[50px] rounded-lg">
                            {heading
                              .filter((col) => col.enabled !== false)
                              .map((col, idx) => (
                                <th
                                  style={{ minWidth: `${col?.minWidth}px` }}
                                  key={idx}
                                  className="px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]"
                                >
                                  <div
                                    className="flex items-center gap-2 w-full text-nowrap"
                                    style={{
                                      justifyContent:
                                        col?.alignment === "right"
                                          ? "flex-end"
                                          : col?.alignment === "center"
                                          ? "center"
                                          : "flex-start",
                                    }}
                                  >
                                    {col?.label}
                                  </div>
                                </th>
                              ))}
                          </tr>
                        </thead>
                        <tbody>
                          {values?.filters?.items?.length > 0 ? (
                            <>
                              {" "}
                              {values?.filters?.items?.map((batch, index) => (
                                <tr
                                  key={batch.item_batch_number || index}
                                  className={`cursor-pointer transition-all  ${
                                    index % 2 === 0
                                      ? " bg-[var(--create-table-row-alt-bg)]"
                                      : " bg-[var(--create-table-row-bg)]"
                                  }   h-[48px]`}
                                >
                                  {heading
                                    .filter((col) => col.enabled !== false)
                                    .map((col, colIndex) => (
                                      <td
                                        style={{
                                          minWidth: `${col?.minWidth}px`,
                                          textAlign: col?.alignment, // Keep textAlign for normal text cells
                                        }}
                                        key={colIndex}
                                        className="border-b border-[var(--create-table-border)] px-[8px] text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)]  whitespace-nowrap cursor-pointer"
                                      >
                                        {col?.value ===
                                        "item_correction_quantity" ? (
                                          <input
                                            type="text"
                                            value={
                                              corrDisplays[index] ??
                                              (batch.item_correction_quantity ?? "")
                                            }
                                            onChange={(e) => {
                                              const val = e.target.value;
                                              if (/^[+\-]?\d*$/.test(val)) {
                                                setCorrDisplays((prev) => ({
                                                  ...prev,
                                                  [index]: val,
                                                }));
                                                if (val !== "+" && val !== "-") {
                                                  handleCorrectionQtyChange(
                                                    index,
                                                    val
                                                  );
                                                }
                                              }
                                            }}
                                            className="min-h-[33px] px-2 border border-[var(--pay-met-input-border)] focus:outline-none bg-[var(--pay-met-input-bg)] text-[var(--pay-met-val-color)] text-[length:var(--pay-met-val-fs)] font-[var(--pay-met-val-fw)] border-radius input-field-no-spin-buttons w-[4rem]"
                                          />
                                        ) : (
                                          truncateString(
                                            batch[col.value] || "",
                                            100
                                          ) ?? "--"
                                        )}
                                      </td>
                                    ))}
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td
                                colSpan={
                                  heading?.filter((h) => h?.enabled !== false)
                                    .length
                                }
                                className="text-center py-4 text-[length:var(--tab-empty-comp-fs)] border-b border-[var(--create-table-border)] font-[var(--tab-empty-comp-fw)] text-[var(--tab-empty-comp-fg)]"
                              >
                                No Data found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
                <div className="flex justify-between h-[50px] items-center px-3">
                  <AddButton
                    prefixIcon={false}
                    onclkFn={() => {
                      setFieldValue("filters", {
                        initials: "",
                        item_category: "",
                        item_group: "",
                        bin_location: "",
                        item_type: "",
                        manufacturer: "",
                        items: [],
                      });
                      setFormKey((prev) => prev + 1); // ensure UI updates
                    }}
                    text={<span>Clear Filters</span>}
                    className="flex h-[32px]  items-center gap-2 text-[var(--close-button-bg)] border-radius px-3 border border-[var(--close-button-bg)]"
                  />
                  <AddButton
                    onclkFn={() => {
                      const existingItems = values?.stockAuditRecordData || [];
                      const newItems = values?.filters?.items || [];

                      // Create a map with existing items
                      const updatedItemsMap = new Map();

                      existingItems.forEach((item) => {
                        const key = `${item.item_id}_${
                          item.item_batch_number
                        }_${item.item_rack_location || ""}`;
                        updatedItemsMap.set(key, item);
                      });

                      // Prepare and merge only selected keys from new items
                      newItems.forEach((item) => {
                        const key = `${item.item_id}_${
                          item.item_batch_number
                        }_${item.bin_location || ""}`; // use bin_location from filters

                        const filteredItem = {
                          item_code: item?.item_code || "",
                          item_name: item?.item_name || "",
                          item_batch_number: item?.item_batch_number || "",
                          item_uom: item?.uom_name || "",
                          item_batch_purchase_rate:
                            item?.item_batch_purchase_rate || 0,
                          item_quantity: item?.item_quantity || "",
                          item_correction_quantity:
                            item?.item_correction_quantity || "",
                          updated_quantity: item?.updated_quantity || "",
                          item_id: item?.item_id || "",
                          item_generic_name: item?.item_generic_name || "",
                          item_uom_id: item?.item_uom || "",
                          item_exp_date: item?.item_exp_date || "",
                          item_mfg_date: item?.item_mfg_date || "",
                          item_total_amount: item?.item_total_amount || 0,
                          correction: item?.correction || "-",
                          item_current_amount: item?.item_current_amount || 0,
                          item_adjusted_amount:
                            item?.item_adjusted_amount || "",
                          item_current_adjusted_diff:
                            item?.item_current_adjusted_diff || "",
                          to_bin_id: item?.to_bin_id || "",
                          item_rack_location: item?.bin_location || "", // assigning to correct key
                        };

                        updatedItemsMap.set(key, filteredItem);
                      });

                      const mergedItems = Array.from(updatedItemsMap.values());
                      const total_items_count = mergedItems.length;

                      const total_matched_item = mergedItems.filter(
                        (row) =>
                          parseFloat(row.item_quantity || 0) ===
                          parseFloat(row.updated_quantity || 0)
                      ).length;

                      const total_miss_matched_item =
                        total_items_count - total_matched_item;

                      let total_added_item_value = 0;
                      let total_removed_item_value = 0;

                      mergedItems.forEach((row) => {
                        const diff = parseFloat(
                          row.item_current_adjusted_diff || 0
                        );
                        if (diff > 0) total_added_item_value += diff;
                        else total_removed_item_value += Math.abs(diff);
                      });

                      const total_item_net_difference =
                        total_added_item_value - total_removed_item_value;

                      setFieldValue(`stockAuditRecordData`, mergedItems);
                      setFieldValue("total_items_count", total_items_count);
                      setFieldValue("total_matched_item", total_matched_item);
                      setFieldValue(
                        "total_miss_matched_item",
                        total_miss_matched_item
                      );
                      setFieldValue(
                        "total_added_item_value",
                        total_added_item_value.toFixed(2)
                      );
                      setFieldValue(
                        "total_removed_item_value",
                        total_removed_item_value.toFixed(2)
                      );
                      setFieldValue(
                        "total_item_net_difference",
                        total_item_net_difference.toFixed(2)
                      );
                      setOpen(false);
                      setFieldValue("filters", {
                        initials: "",
                        item_category: "",
                        item_group: "",
                        bin_location: "",
                        item_type: "",
                        manufacturer: "",
                        items: [],
                      });
                    }}
                    prefixIcon={false}
                    text="Load Items"
                    className="
    flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-font-size)] 
    font-[var(--primary-button-font-weight)]
  "
                    type="submit"
                  />
                </div>

                <LoadingOverlay />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

const heading = [
  { label: "Item Code", value: "item_code" },
  { label: "Item Name", value: "item_name" },
  { label: "Batch No", value: "item_batch_number" },
  { label: "UOM", value: "uom_name" },
  { label: "Bin Location", value: "bin_location" },
  { label: "Available Qty", value: "item_quantity" },
  { label: "Correction (+/-)", value: "item_correction_quantity" },
  { label: "Updated Qty", value: "updated_quantity" },
];
